import { HardHat, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-xl border border-slate-200 shadow-sm p-6 sm:p-10 space-y-6">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-md bg-[#0044FF] grid place-items-center">
            <HardHat className="h-6 w-6 text-white" strokeWidth={2.5} />
          </div>
          <h1 className="font-heading font-black text-2xl tracking-tight">
            Informativa sulla Privacy — IL-Report
          </h1>
        </div>
        <p className="text-xs text-slate-400">Ultimo aggiornamento: 28 luglio 2026</p>

        <section className="space-y-4 text-sm text-slate-700 leading-relaxed">
          <h2 className="font-heading font-bold text-lg">1. Titolare del trattamento</h2>
          <p>
            La Baita di Lollio Ivan — contatto: <a className="underline" href="mailto:ivan.lollio@gmail.com">ivan.lollio@gmail.com</a>
          </p>

          <h2 className="font-heading font-bold text-lg">2. Dati raccolti</h2>
          <p>
            IL-Report è un gestionale per la rilevazione delle ore di lavoro. Trattiamo:
            dati account (nome, email, password cifrata), dati aziendali inseriti
            dall'azienda cliente (nomi dei dipendenti, ore lavorate, commesse,
            clienti dell'azienda), log tecnici di accesso.
          </p>

          <h2 className="font-heading font-bold text-lg">3. Finalità</h2>
          <p>
            I dati sono trattati esclusivamente per erogare il servizio: gestione
            rapportini, statistiche, stampe PDF, invio email di riepilogo agli
            amministratori dell'azienda, gestione dell'abbonamento.
          </p>

          <h2 className="font-heading font-bold text-lg">4. Isolamento dei dati</h2>
          <p>
            Ogni azienda dispone di uno spazio dati separato e isolato. I dati di
            un'azienda non sono mai visibili ad altre aziende.
          </p>

          <h2 className="font-heading font-bold text-lg">5. Servizi di terze parti</h2>
          <p>
            Pagamenti: <b>Stripe</b> (i dati delle carte non transitano mai sui nostri
            server). Email: <b>Resend</b>. Hosting: infrastruttura cloud europea/USA
            con misure di sicurezza standard di settore.
          </p>

          <h2 className="font-heading font-bold text-lg">6. Conservazione</h2>
          <p>
            I dati restano disponibili per tutta la durata dell'abbonamento. Alla
            cessazione, l'azienda può richiederne l'esportazione o la cancellazione
            definitiva scrivendo al contatto sopra indicato.
          </p>

          <h2 className="font-heading font-bold text-lg">7. Diritti dell'interessato</h2>
          <p>
            Ai sensi del GDPR (Reg. UE 2016/679) puoi richiedere accesso, rettifica,
            cancellazione, limitazione e portabilità dei tuoi dati scrivendo a{" "}
            <a className="underline" href="mailto:ivan.lollio@gmail.com">ivan.lollio@gmail.com</a>.
          </p>

          <h2 className="font-heading font-bold text-lg">8. Sicurezza</h2>
          <p>
            Password cifrate con bcrypt, comunicazioni protette da HTTPS/TLS, accessi
            tracciati, backup periodici.
          </p>
        </section>

        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-[#0044FF] underline" data-testid="privacy-back-link">
          <ArrowLeft className="h-3.5 w-3.5" /> Torna all'app
        </Link>
      </div>
    </div>
  );
}
